module.exports = __webpack_public_path__ + "static/media/SellerboxFunction03.4dbb46c1.png";